import React from 'react'
import { makeStyles, Box, Button, Typography, Grid } from '@material-ui/core'

import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'

import { Link } from 'react-router-dom'
import ProgressBar from './ProgressBar'

const estilos = makeStyles((theme) => ({
  botonPersonalizado: {
    background: 'linear-gradient(45deg, #018786 30%, #018786 90%)',
    border: 0,
    borderRadius: 100,
    color: 'white',
    height: 48,
    padding: '5px 20px',
    fontSize: 20,
    fontWeight: 400,
    width: 140,
    marginBottom: 50,
  },
}))

const TestParteUno = ({ formState, handleChange }) => {
  const classes = estilos()

  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      height="100%"
    >
      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <Box ml={4} mb={4}>
          <Typography variant="body2" color="initial">
            Según la OMS, los signos y síntomas de la enfermedad por coronavirus
            2019 (COVID-19) pueden aparecer entre dos y 14 días después de la
            exposición al virus.
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <Box mb={4}>
          <ProgressBar value={33} />
        </Box>
      </Grid>

      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <Box ml={4} mb={6} alignItems="left">
          <Typography variant="h4">PARTE I</Typography>
          <Typography variant="h4">Sintomas Primarios</Typography>
        </Box>
      </Grid>

      <Grid item>
        <FormControl component="fieldset">
          <FormLabel component="legend">¿Tiene usted fiebre?</FormLabel>
          <RadioGroup
            row
            aria-label="fiebre"
            defaultValue="end"
            name="radioAFiebre"
            value={formState.radioAFiebre}
            onChange={handleChange}
          >
            <FormControlLabel
              value="start"
              control={<Radio color="primary" />}
              label="Si"
              labelPlacement="start"
            />

            <FormControlLabel
              value="end"
              control={<Radio color="primary" />}
              label="No"
              labelPlacement="start"
            />
          </RadioGroup>
          <FormLabel component="legend">¿Tiene usted Tos?</FormLabel>
          <RadioGroup
            row
            aria-label="tos"
            defaultValue="end"
            name="radioBTos"
            value={formState.radioBTos}
            onChange={handleChange}
          >
            <FormControlLabel
              value="start"
              control={<Radio color="primary" />}
              label="Si"
              labelPlacement="start"
            />

            <FormControlLabel
              value="end"
              control={<Radio color="primary" />}
              label="No"
              labelPlacement="start"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item>
        <Box mt={4}>
          <Link to="/test" className="navbarLinks">
            <Button
              size="large"
              className={classes.botonPersonalizado}
              disableElevation
            >
              ANTERIOR
            </Button>
          </Link>
          <Link to="/TestParteDos" className="navbarLinks">
            <Button
              size="large"
              className={classes.botonPersonalizado}
              disableElevation
              style={{ marginLeft: '10vw' }}
            >
              SIGUIENTE
            </Button>
          </Link>
        </Box>
      </Grid>

      <Grid item>
        <Box ml={4}>
          <Typography variant="body2">
            Asegurate de examinarte bien antes de seleccionar tu respuesta.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  )
}

export default TestParteUno
